import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { copilotV2GetLatestOrCreateThread } from '../../threads/actions/copilotV2GetLatestOrCreateThread';
import { getChatspotAuthInfo } from '../api/chatspotAuthAPI';
export const initialState = {
  authInfo: {},
  authInfoStatus: 'idle',
  isHipaaCoveredEntity: false
};
export const fetchChatspotAuthInfo = createAsyncThunk('chatspotAuth/fetchAuthInfo', getChatspotAuthInfo);
const chatspotAuthSlice = createSlice({
  name: 'chatspotAuth',
  initialState,
  reducers: {
    onboardingCompleted: state => {
      state.authInfo.onboardingComplete = true;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchChatspotAuthInfo.pending, state => {
      state.authInfoStatus = 'pending';
    });
    builder.addCase(fetchChatspotAuthInfo.fulfilled, (state, action) => {
      state.authInfo = action.payload;
      state.authInfoStatus = 'succeeded';
    });
    builder.addCase(fetchChatspotAuthInfo.rejected, state => {
      state.authInfoStatus = 'failed';
    });
    builder.addCase(copilotV2GetLatestOrCreateThread.rejected, (state, action) => {
      const payload = action.payload;
      if ((payload === null || payload === void 0 ? void 0 : payload.type) === 'HIPAA_PORTAL_ACCESS_DENIED') {
        state.isHipaaCoveredEntity = true;
      }
    });
  }
});
export const {
  onboardingCompleted
} = chatspotAuthSlice.actions;
export default chatspotAuthSlice.reducer;